var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"ccos-input__radio",class:{
        'ccos-input__radio--disabled': _vm.disabled,
    }},_vm._l((Object.entries(_vm.options)),function(ref){
    var guid = ref[0];
    var option = ref[1];
return _c('li',{key:guid,class:[
            'radio__option',
            {
                'radio__option--selected': guid === _vm.newValue,
            }
        ],on:{"click":function($event){return _vm.select(guid)}}},[_c('div',{staticClass:"radio__content"},[_c('label',{staticClass:"radio__label",attrs:{"for":_vm.name}},[_vm._v(" "+_vm._s(option[_vm.labelKey])+" ")]),_c('input',{staticClass:"radio__input ccos-input__el ccos-input__el--radio",attrs:{"type":"radio","name":_vm.name,"disabled":_vm.disabled},domProps:{"checked":guid === _vm.newValue}}),_vm._m(0,true)])])}),0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"radio__box"},[_c('div',{staticClass:"box__circle"})])}]

export { render, staticRenderFns }